import { GET_STORIES, GET_STORIES_FEATURED } from '../actions/storiesActions';

const initialState = {
    stories: [],
    featuredStories: [],
    storiesIsFetching: false,
    featuredStoriesIsFetching: false
};

export function stories(state = initialState, action)
{
    switch (action.type)
    {
        case GET_STORIES.pending:
        {
            return {
                ...state,
                storiesIsFetching: true,
                stories: initialState.stories
            };
        }
        case GET_STORIES.fulfilled:
        {
            return {
                ...state,
                lastError: {},
                storiesIsFetching: false,
                stories: action.payload
            };
        }

        case GET_STORIES.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                storiesIsFetching: false,
                stories: initialState.stories
            };
        }
        case GET_STORIES_FEATURED.pending:
        {
            return {
                ...state,
                featuredStoriesIsFetching: true,
                featuredStories: initialState.featuredStories
            };
        }
        case GET_STORIES_FEATURED.fulfilled:
        {
            return {
                ...state,
                lastFeaturedError: {},
                featuredStoriesIsFetching: false,
                featuredStories: action.payload
            };
        }

        case GET_STORIES_FEATURED.rejected:
        {
            return {
                ...state,
                lastFeaturedError: action.payload,
                featuredStoriesIsFetching: false,
                featuredStories: initialState.featuredStories
            };
        }
    }

    return state;
}
